export const districtScreenerIntroSteps = (isDistrict: boolean = false) => [
  {
    element: '#help-tour-btn',
    intro: 'Click here to take a tour of this page.'
  },
  {
    element: '#schoolFilter',
    intro: 'Select a school from the dropdown to view WordFlight Screener data for that school.',
  },
  {
    element: '#printButton',
    intro: 'Click here to print the Screener Report.'
  },
  {
    element: '.report',
    intro: 'Screener is where you can find overview information on the WordFlight Screener. You can see the Screener enrollment, completion, and results at the school level. You can also see the percentage of students who have completed the Screener sorted by teacher.'
  },
  {
    element: '#district-report-screener-enrollment',
    intro: isDistrict
      ? 'See the Screener enrollment data for the district or selected school. See how many students are enrolled in the WordFlight Screener.'
      : 'See your school’s Screener enrollment data. See how many students are enrolled in the WordFlight Screener.'
  },
  {
    element: '#district-report-screener-completion',
    intro: 'See the percentage of students who have completed the WordFlight Screener.'
  },
  {
    element: '#district-report-screener-performance',
    intro: 'See the percentage of students and number of students in each risk category. The WordFlight Screener sorts '
      + 'students into three risk categories: High Risk, Some Risk, and Proficient. WordFlight recommends students in the '
      + 'High Risk and Some Risk categories as excellent candidates for the WordFlight System. Students in the borderline '
      + 'proficiency range should also be considered as possible candidates for WordFlight. Some students in this range may '
      + 'still benefit from the extra support and practice. Borderline proficiency for grades 2-4 is the range of 400-450. '
      + 'Borderline proficiency for grades 5+ is the range of 300- 350.'
  },
  {
    element: '#school-report',
    intro: 'Click the plus sign to view WordFlight Screener data sorted by school. See the school name, number of teachers, number of WordFlight students, and the percentage of students who have completed the WordFlight Screener for the selected school.'
  },
  {
    element: '#teacher-report',
    intro: 'Click the plus sign to view WordFlight Screener data sorted by teacher. See the teacher’s name, the grades they teach, their school, and the percentage of their students who have completed the WordFlight Screener.'
  }
];
